import { CommonGet, CommonPost, CommonGetIDServer } from "../../../utils/CommonFetch";
import tokenDecoder from '../../../components/Common/tokenDecoder';

export default {
    getGroups,
    getEstatesByGroupID,
    syncData,
    getBPLMasterDataTypes,
    getSyncedData
};
async function syncData(data) {
    const formData = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        masterDataTypeID: parseInt(data.masterDataTypeID),
        createdBy: parseInt(tokenDecoder.getUserIDFromToken()),
    }
    var result = await CommonPost('/api/BPLMasterDataSync/SyncData', null, formData);

    return result;
}

async function getBPLMasterDataTypes() {
    const response = await CommonGet('/api/BPLMasterDataSync/GetBPLMasterDataTypes', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["masterDataTypeID"]] = item[1]["masterDataTypeName"]
    }
    return array;
}

async function getEstatesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupId=' + groupID);
    let array = []
    for (let item of Object.entries(response.data)) {
            array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return array;
}

async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getSyncedData(model) {
    var response = await CommonPost('/api/BPLMasterDataSync/GetSyncedMasterData',null, model);
    return response.data;
}
